import { ENUM_LANGUAGE_TEXT } from 'constants/enum';
import { SET_LANGUAGE, SET_LANGUAGE_LOADING, SET_LANGUAGE_INITIALIZED } from 'store/types/language';

const initialState = {
  currentLanguage: ENUM_LANGUAGE_TEXT.JAPANESE,
  isLoading: true,
  isInitialized: false,
  availableLanguages: [
    { code: ENUM_LANGUAGE_TEXT.JAPANESE, name: '日本語', flag: 'jp-JP', shortName: 'JP' },
    { code: ENUM_LANGUAGE_TEXT.ENGLISH, name: 'English', flag: 'en-US', shortName: 'EN' },
    { code: ENUM_LANGUAGE_TEXT.VIETNAMESE, name: 'Tiếng Việt', flag: 'vi-VN', shortName: 'VI' },
  ],
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        currentLanguage: action.payload,
      };
    case SET_LANGUAGE_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_LANGUAGE_INITIALIZED:
      return {
        ...state,
        isInitialized: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
